import { useDispatch, useSelector } from "react-redux";
import { setCurrentStep } from "reducer";
import "./StepsConfig.scss";
import Icon from "@mdi/react";
import { mdiCheck } from "@mdi/js";

const StepsConfig = () => {
  const dispatch = useDispatch();
  const currentStep = useSelector(({ currentStep }) => currentStep);
  const isHydraulicSet = useSelector(
    ({ is_hydraulic_set }) => is_hydraulic_set
  );
  const isElectricSet = useSelector(({ is_electric_set }) => is_electric_set);
  const hydraulicLines = useSelector(({ lines }) => lines.hydraulic);
  const electricLines = useSelector(({ lines }) => lines.electric);
  const circles = useSelector(({ circles }) => circles);

  const hydraulicCircles = circles.filter(
    (circle) => circle?.type === "hydraulic" && circle.setting
  ).length;

  const steps = [
    {
      index: 1,
      text: "Select Hydraulic Lines",
      isCompleted: hydraulicLines > 0,
    },
    {
      index: 2,
      text: "Configure Hydraulic Lines",
      isCompleted:
        hydraulicCircles === hydraulicLines &&
        isHydraulicSet &&
        hydraulicLines > 0,
    },
    {
      index: 3,
      text: "Select Electric Lines",
      isCompleted: isElectricSet && electricLines >= 0,
    },
    {
      index: 4,
      text: "Done, Continue.",
      isCompleted: false,
    },
  ];

  const handleStepClick = (step) => {
    if (step.isCompleted || step.index === currentStep) {
      dispatch(setCurrentStep(step.index));
    }
  };

  return (
    <div className="configurator__steps-header">
      <div className="steps-bar">
        {steps.map((step, i) => (
          <div
            className={`step-item ${step.isCompleted ? "completed" : ""} ${
              step.index === currentStep ? "active" : ""
            }`}
            key={i}
            onClick={() => handleStepClick(step)}
          >
            <div className="step-circle">
              {step.isCompleted ? (
                <Icon path={mdiCheck} size={0.7} />
              ) : (
                <span>{step.index}</span>
              )}
            </div>
            <span className="step-text">{step.text}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StepsConfig;
